// store/thunks/auth/sendRecoveryTwoFactorThunk.ts
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import type { VerificationDTO } from '@/types/DTOs';

export const sendRecoveryTwoFactorThunk = createAppAsyncThunk<
  VerificationDTO,
  { recoveryToken: string },
  { rejectValue: { message: string } }
>(
  'auth/sendRecoveryTwoFactorThunk',
  async({ recoveryToken }, { extra: { authService }, rejectWithValue }) => {
    try {
      return await authService.sendRecoveryTwoFactor({ recoveryToken });
    } catch (caught) {
      const message =
        caught instanceof Error ? caught.message : 'Failed to send reset password email';
      return rejectWithValue({ message });
    }
  }
);
